module.exports = "/_next/static/images/dd4ab8e91a549fce6e3a9a8868b49b6d-nubanker-xpeer@2x.jpg";